import * as types from './mutation-types'

export default {
  [types.SET_LIST] : (state, obj) =>{
    state.list = obj.list
  },
  [types.SET_SELECTED] : (state, obj) =>{
    state.selected = obj
  }
}



// WEBPACK FOOTER //
// ./src/features/Arvore/store/mutations.js